import { getAPIUrl } from "../config";

const API_URL = getAPIUrl();

const authedFetch = async (getAccessTokenSilently, path, options = {}) => {
  const token = await getAccessTokenSilently();
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || `Request failed (${response.status})`);
  }

  return response.json();
};

export const fetchAuditEvents = async (venueId, getAccessTokenSilently, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.action) params.set("action", filters.action);
  if (filters.actor) params.set("actor", filters.actor);
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  const qs = params.toString();
  const path = `/api/v1/venues/${venueId}/audit-events${qs ? `?${qs}` : ""}`;
  return authedFetch(getAccessTokenSilently, path, { method: "GET" });
};
